import authorityListeners from '@authority/authority-shared/utilities/redux/listeners';

export const mapActionReducers = {
  
  ...authorityListeners
};